import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('tmv_v10_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('tmv_v10_token');
      localStorage.removeItem('tmv_v10_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// Downloads a CSV from an authenticated endpoint (export/template routes
// require the Bearer token, so a plain <a href> link won't work — this goes
// through the same axios instance, then triggers a real browser download).
export async function downloadCsv(path, filename, params) {
  const response = await api.get(path, { responseType: 'blob', params });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

// Export params for a client-side-filtered list page: when the filters have
// narrowed the list, pass the visible rows' ids so the CSV matches the
// screen (server side: onlyRequestedIds in utils/csvExport.js). Unfiltered
// lists send nothing and export everything, as before.
export function exportIdsParam(filteredRows, allRows) {
  if (!allRows || filteredRows.length === allRows.length) return undefined;
  return { ids: filteredRows.map(r => r.id).join(',') };
}
